/* jscpd:ignore-start */
import { fetchFromVolatileServer } from "../fetchFromVolatileServer";
import { getServiceURL } from "../url";
import { FavoriteRecipesReturn, fetchUser } from "./user";
export async function addToShoppingList(recipeId: number, locale?: string) {
  try {
    const user = await fetchUser(undefined, locale);
    const url = `${getServiceURL(locale)}/user/${user?.data?.id}/shoppinglist/${recipeId}`;
    return (
      user &&
      fetchFromVolatileServer(`${url}`, {
        method: "PUT",
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) {
            console.error("Response not ok for", url, res.status);
            throw new Error("Response not ok");
          }
          return res.json();
        })
        .catch((err) => {
          console.error(err);
          return null;
        })
    );
  } catch (err) {
    console.error(err);
    return;
  }
}
export async function deleteFromShoppingList(
  recipeId: number,
  locale?: string,
) {
  try {
    const user = await fetchUser(undefined, locale);
    return (
      user &&
      fetchFromVolatileServer(
        `${getServiceURL(locale)}/user/${user.data.id}/shoppinglist/${recipeId}`,
        {
          method: "DELETE",
          credentials: "include",
        },
      )
        .then((res) => {
          if (!res.ok) {
            console.error(res.status);
            throw new Error("Response not ok");
          }
          return res.json();
        })
        .catch((err) => {
          console.error(err);
          return null;
        })
    );
  } catch (err) {
    console.error(err);
    return;
  }
}
export async function getShoppingList(
  locale?: string,
): Promise<FavoriteRecipesReturn[] | null> {
  try {
    const user = await fetchUser(undefined, locale);
    return (
      user &&
      fetchFromVolatileServer(
        `${getServiceURL(locale)}/user/${user.data.id}/shoppinglist`,
        {
          method: "GET",
          credentials: "include",
        },
      )
        .then((res) => {
          if (!res.ok) {
            console.error(res.status);
            throw new Error("Response not ok");
          }
          return res.json();
        })
        .catch((err) => {
          console.error(err);
          return null;
        })
    );
  } catch (err) {
    console.error(err);
    return null;
  }
}
/* jscpd:ignore-end */
